import Table from './Table.vue'
import AlertPanel from './Notifications/AlertPanel.vue'
import NestedReferenceTree from './Notifications/NestedReferenceTree.vue'
import AnalyticalPlotConfig from './Plot/AnalyticalPlotConfig.vue'
import NumericalPlotConfig from './Plot/NumericalPlotConfig.vue'
import NumericalComparisonPlotConfig from './Plot/NumericalComparisonPlotConfig.vue'
import AnalyticalResultDisplay from '../views/AnalyticalModel/AnalyticalResultDisplay.vue' // TODO MFI change the path to ./Dashboard/AnalyticalResultDisplay.vue'
import ThreeDSpacecraftShape from './3Dviewer/3DSpacecraftshape'
import DeploymentResultDisplay from '../views/Deployment/DeploymentResultDisplay.vue'
import GeometriesDisplayTable from '../views/AnalyticalConstellation/GeometriesDisplayTable.vue'

const components = {
  install(Vue) {
    Vue.component(Table.name, Table)
    Vue.component(AlertPanel.name, AlertPanel)
    Vue.component(NestedReferenceTree.name, NestedReferenceTree)
    Vue.component(AnalyticalResultDisplay.name, AnalyticalResultDisplay)
    Vue.component(DeploymentResultDisplay.name, DeploymentResultDisplay)
    Vue.component(AnalyticalPlotConfig.name, AnalyticalPlotConfig)
    Vue.component(NumericalPlotConfig.name, NumericalPlotConfig)
    Vue.component(
      NumericalComparisonPlotConfig.name,
      NumericalComparisonPlotConfig
    )
    Vue.component(ThreeDSpacecraftShape.name, ThreeDSpacecraftShape)
    Vue.component(GeometriesDisplayTable.name, GeometriesDisplayTable)

    // These components are temporary views, but they will be integrated in the resultsView
    Vue.component(
      'numericalResultDisplay',
      require('../views/NumericalModel/NumericalResultDisplay.vue').default
    )
  }
}

export default components
